import inputmask from "inputmask";
import {
    alertHTML,
    b64Uri,
    bodyRequest,
    getData,
    getElement,
    getJson,
    requestOptions,
    resetForm,
    setSelect2Ajax,
    tryAsyncFetch,
} from "../../../../../helpers";
import bootstrap from "bootstrap/dist/js/bootstrap";

export class BankModal extends HTMLDivElement {
    connectedCallback() {
        // console.log(this);
        const Form = getElement("[data-form=form]", this);

        Form.elements.save.addEventListener("click", async () => {
            if (Form.reportValidity() && this.accountValidate()) {
                if (getData(Form.elements.save, "data-request") == "http") {
                    Form.submit();
                } else {
                    let body = new FormData(Form);
                    requestOptions.body = body;
                    let response = await tryAsyncFetch(
                        Form.action,
                        requestOptions
                    );
                    requestOptions.body = bodyRequest; // regresar el bodyRequest predeterminado

                    if (response.success) {
                        Form.elements.closeModal.click();
                        alertHTML(response.message, "success");
                        // El modo pro solo si lo piden, aquí lanzar un custom event para devolver la data y poder setear el target
                    } else {
                        alertHTML(response.message);
                    }
                }
            }
        });

        this.addEventListener("click", (e) => {
            /**
             * Solución modal anidados bootstrap
             */
            const CloseModal = e.target.closest("[data-bs-dismiss=modal]");

            if (CloseModal) {
                const BD = document.querySelectorAll(".modal-backdrop");

                BD?.forEach((item) => {
                    item.remove();
                });
                const OldModal = getElement(
                    getData(CloseModal, "data-modal-target")
                );

                if (OldModal) {
                    const M = bootstrap.Modal.getOrCreateInstance(OldModal);
                    M.show();
                }
            }
        });

        const AccountMask = new inputmask("AA##-####-####-####-####-####");
        AccountMask.mask(Form.elements.account);
    }

    static create(modal, title, url) {
        const Form = getElement("[data-form=form]", getElement(modal));
        resetForm(Form, title, url);
    }

    static edit(modal, title, url, data) {
        data = getJson(b64Uri(data, "decode"));
        const Form = getElement("[data-form=form]", getElement(modal));
        resetForm(Form, title, url);
        Form.elements.name.value = data.pivot.name;
        Form.elements.description.value = data.pivot.description;
        Form.elements.account.value = data.account;
        setSelect2Ajax(
            Form.elements.financial_id,
            data.financial.id,
            data.financial.name
        );
    }

    accountValidate() {
        const Form = getElement("[data-form=form]", this);

        if (Form.elements.account.value.includes("_")) {
            alertHTML("La cuenta está incompleta", "error");

            return false;
        }

        return true;
    }
}

window.customElements.define("bank-modal", BankModal, {
    extends: "div",
});
